import {  CloudFeatures } from "../../types/features";
import { User } from "../../types/user";

export function hasFeature(user?: User, feature?: CloudFeatures ): boolean {

    if (!user?.features || !feature) {
        return false;
    }

    return user.features.includes(feature);
}

export function hasDeviceFeature(deviceFeatures: string[], deviceType?: string, deviceFeature?:  string): boolean {

    if (!deviceFeatures || deviceFeatures === undefined || deviceFeatures.length <= 0 || !deviceFeature) {
        return false;
    }

    return deviceFeatures.includes(deviceFeature);
}


